import React from "react";

const SubmitBtn = () => {
  return (
    <button
      type="submit"
      className="bg-primary-darker w-full  block text-white rounded-md p-5 mt-5 font-bold hover:bg-primary-light transition-all duration-300 shadow-sm shadow-slate-300 hover:shadow-primary-light/50 hover:shadow-md active:bg-primary-light active:shadow-md"
    >
      Submit
    </button>
  );
};

export default SubmitBtn;
